import Reveal from "@/components/base/Reveal";
import { marqueeWords, siteInfo, siteStats } from "@/mocks/site";

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20poster%20scene%20with%20torn%20paper%20layers%20and%20deep%20crimson%20ink%20splashes%20on%20a%20warm%20charcoal%20desk%2C%20dramatic%20side%20lighting%2C%20film%20grain%2C%20high%20contrast%20negative%20space%20in%20the%20center%20for%20text%2C%20cinematic%20documentary%20mood%2C%20no%20people&width=1600&height=900&seq=expose-hero-01&orientation=landscape"
          alt="曝光档案局的档案桌面与朱红印章，象征翻车现场档案"
          title="渣男曝光翻车现场合集 · 曝光档案局"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/80" />
      </div>

      <div className="relative mx-auto w-full max-w-[1180px] px-4 pb-16 pt-28 md:px-6 md:pb-24 md:pt-40">
        <Reveal>
          <div className="flex flex-col items-center text-center">
            <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs text-background-100 backdrop-blur">
              <i className="ri-flashlight-fill text-primary-400" />
              {siteInfo.weeklyUpdate}
            </span>

            <h1 className="mt-6 font-heading text-[32px] font-black leading-tight text-background-50 md:text-6xl">
              {siteInfo.name}
              <span className="mt-3 block text-lg font-semibold tracking-[0.2em] text-primary-300 md:text-2xl">
                渣男曝光 · 翻车现场合集
              </span>
            </h1>

            <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
              {siteInfo.description}
              从被拆穿瞬间到打脸现场，从被抓现行到社死瞬间，每一份档案都只保留情节、隐去身份。
            </p>

            <div className="mt-8 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href="#featured"
                className="inline-flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-500 sm:w-auto"
              >
                <i className="ri-fire-line text-base" />
                直击热门现场
              </a>
              <a
                href="#guide"
                className="inline-flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10 sm:w-auto"
              >
                <i className="ri-shield-star-line text-base" />
                先看避雷指南
              </a>
            </div>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <dl className="mt-14 grid grid-cols-2 gap-3 md:mt-20 md:grid-cols-4 md:gap-5">
            {siteStats.map((stat) => (
              <div
                key={stat.id}
                className="rounded-lg border border-background-50/15 bg-background-50/10 px-4 py-5 backdrop-blur md:px-5 md:py-6"
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600/85 text-background-50">
                  <i className={`${stat.icon} text-base`} />
                </span>
                <dd className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-3xl">
                  {stat.value}
                  <span className="ml-1 text-xs font-normal text-background-300">{stat.unit}</span>
                </dd>
                <dt className="mt-1 text-xs text-background-300 md:text-sm">{stat.label}</dt>
              </div>
            ))}
          </dl>
        </Reveal>
      </div>

      <div className="relative border-t border-background-50/15 bg-foreground-950/80 py-3">
        <div className="flex w-max animate-rr-marquee items-center gap-8 whitespace-nowrap">
          {[...marqueeWords, ...marqueeWords].map((word, idx) => (
            <span key={`${word}-${idx}`} className="flex items-center gap-8 text-xs text-background-300 md:text-sm">
              {word}
              <i className="ri-star-s-fill text-[8px] text-primary-500" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}